import { FC, useMemo, useState } from "react";
import { Item, ItemProps } from ".";

interface PasswordProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
    placeholder?: string;
}

const Password: FC<PasswordProps> = ({ value, onChange, col, error, label, placeholder, required, itemClassName }) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputClassName = useMemo(() => {
        let className = `@app-form-password w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500 pr-10`;
        if (Boolean(error)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        return className;
    }, [error]);

    return (
        <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName}>
            <div className="relative">
                <input
                    autoComplete="new-password"
                    value={value || ""}
                    onChange={e => onChange && onChange(e.currentTarget.value)}
                    type={showPassword ? "text" : "password"}
                    className={inputClassName}
                    placeholder={placeholder}
                />
                <button
                    type="button"
                    onClick={() => setShowPassword(p => !p)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                >
                    {showPassword ? (
                        <i className="fas fa-eye-slash"></i>
                    ) : (
                        <i className="fas fa-eye"></i>
                    )}
                </button>
            </div>
        </Item>
    );
};
export default Password;